import { render, staticRenderFns } from "./SupportMenuDialog.vue?vue&type=template&id=50f3bd8c&scoped=true&"
import script from "./SupportMenuDialog.vue?vue&type=script&lang=js&"
export * from "./SupportMenuDialog.vue?vue&type=script&lang=js&"
import style0 from "./SupportMenuDialog.vue?vue&type=style&index=0&id=50f3bd8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f3bd8c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VSheet})
